import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxSchool from '../util/remote/ajaxSchool';

const initialState = { 
    studentId: null,
    profileInfo: null,
    billSum: 0,
    paidSum: 0,
    discountSum: 0,
    feesBalance: '...',
    feesStatement: null,
    metaData: null,
    currentPage: 1,
    openingDate: null,
    closingDate: null,
    mounted: false,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
  };


const FeesProfileContext = createContext();

export const FeesProfileProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(()=>{
    if(state.studentId){
      loadProfile();
    }
  }, [state.studentId])

  useEffect(()=>{
    if(state.mounted){
      getFeesStatement();
    }
  }, [state.currentPage])


  const getStudentInfo = async () => {
    dispatch({ type: 'profileInfo', payload: null});
    const server_response  = await ajaxSchool.fetchStudentProfile(state.studentId);
    if(server_response.status === "OK"){
        dispatch({ type: 'profileInfo', payload: server_response.details});
    }else{
      dispatch({ type: 'profileInfo', payload: '404'});
    }
  };

  const getBalance = async () => {
    dispatch({ type: 'feesBalance', payload: '...'});
    const server_response  = await ajaxSchool.fetchStudentBalance(state.studentId);
    if(server_response.status === "OK"){
        dispatch({ type: 'feesBalance', payload: server_response.details});
    }
  };

  
   const getBilledSum = async()=>{

      const server_response = await ajaxSchool.fetchStudentBilledSum(state.studentId);
      if(server_response.status === "OK"){
          dispatch({ type: "billSum", payload: server_response.details });
      }else{
          dispatch({ type: "billSum", payload: "00.00" });
      }
    }
  
    const getPaidSum = async()=>{
  
      const server_response = await ajaxSchool.fetchStudentPaidSum(state.studentId);
      if(server_response.status === "OK"){
          dispatch({ type: "paidSum", payload: server_response.details });
      }else{
          dispatch({ type: "paidSum", payload: "00.00" });
      }
    }
  
    const getDiscountedSum = async()=>{
      const server_response = await ajaxSchool.fetchStudentDiscountedSum(state.studentId);
      if(server_response.status === "OK"){
          dispatch({ type: "discountSum", payload: server_response.details });
      }else{
        dispatch({ type: "discountSum", payload: "00.00" });
      }
    }

    const getFeesStatement = async(refresh = false, period=null)=>{

      dispatch({ type: "mounted", payload: true });

      if (refresh) {
        dispatch({ type: "feesStatement", payload: null });
        dispatch({ type: "metaData", payload: null });
        setCurrentPage(1);
      }

      const server_response = await ajaxSchool.fetchStudentStatement(
        {
          "student_id":state.studentId,
          "opening_date": period?.opening_date || state.openingDate,
          "closing_date": period?.closing_date || state.closingDate,
          "page":refresh ? 1 : state.currentPage,
          "opening_balance": refresh? 0 : state.feesStatement?.summary?.running_opening_balance || 0
        }
      );
      if(server_response.status === "OK"){
        const newTransactions = server_response.details.data.transactions;
        dispatch({
          type: "feesStatement",
          payload: {
            transactions: refresh
            ? newTransactions
            : state.feesStatement?.transactions
            ? [...state.feesStatement.transactions, ...newTransactions]
            : newTransactions,
            summary: server_response.details.data.summary,
          },
        });

          dispatch({ type: "metaData", payload: server_response.details.meta });

      }else{
        dispatch({ type: "feesStatement", payload: "404" });
        dispatch({ type: "meta", payload: "404" });
      }
    }

  const loadProfile = async() =>{
    setCurrentPage(1);
    dispatch({ type: "feesStatement", payload: null });
    dispatch({ type: "meta", payload: null });
    await getStudentInfo();
    await getBalance();
    await getBilledSum();
    await getPaidSum();
    await getDiscountedSum();
    await getFeesStatement(true);
  }

  const setCurrentPage = (page)=>{
    dispatch({ type: 'currentPage', payload: page });
  }
  return(
    <FeesProfileContext.Provider value={{
      ...state, 
      dispatch, 
      loadProfile,
      getFeesStatement,
      setCurrentPage
      }}>
      {children}
    </FeesProfileContext.Provider>
  )

}

export const useFeesProfile = ()=>useContext(FeesProfileContext);

